export default "__VITE_ASSET__DavU$k1d__"